(function (theWeekDayView, $) {
  var theWeekDaySection;
  var theWeekDaySectionHeight;
  var theWeekDaySectionOffsetTop;

  var screenshots = [];
  var newsTickerHolder, newsTickerText;

  theWeekDayView.init = function () {
    theWeekDaySection = $("#the-week-day-section");

    screenshots = $("#the-week-day-phone-holder .iphone-screenshot-image");

    newsTickerHolder = $("#the-week-day-news-ticker-text-holder");
    newsTickerText = $("#the-week-day-news-ticker-text-holder-inner");

    calculateGeometry();
    setTimeout(calculateGeometry, 2000);
    setTimeout(calculateGeometry, 6000);
    setInterval(calculateGeometry, 18000);

    wireEvents();
  };

  function performOneIterationOfNewsTicker() {
    var newsTickerWidth = newsTickerText[0].scrollWidth + newsTickerHolder.width();
    var timeToAnimate = newsTickerWidth * 10;

    newsTickerText.transit(
      { x: -(newsTickerWidth + newsTickerHolder.width()) + "px" },
      timeToAnimate,
      "linear",
      function () {
        newsTickerText.transit({ x: newsTickerHolder.width() + "px" }, 0, "linear");
        setTimeout(performOneIterationOfNewsTicker, 200);
      },
    );
  }

  function wireEvents() {
    var screenshotIndex = 0;
    setInterval(function () {
      screenshotIndex = (screenshotIndex + 1) % screenshots.length;
      screenshots.removeClass("screenshot-visible");
      $(screenshots[screenshotIndex]).addClass("screenshot-visible");
    }, 5000);

    el.documentElement.bind("WINDOW_SCROLL_EVENT.THE_WEEK_DAY_VIEW", function (evt, windowScrollTop) {
      var additionalOffset = el.windowWidth >= 768 ? theWeekDaySectionHeight : theWeekDaySectionHeight / 3;
      var sectionOffset = windowScrollTop - theWeekDaySectionOffsetTop - additionalOffset + el.windowHeight;

      if (sectionOffset > 0) {
        setTimeout(performOneIterationOfNewsTicker, 1000);
        el.documentElement.unbind("WINDOW_SCROLL_EVENT.THE_WEEK_DAY_VIEW"); // don't listen for scroll anymore
      }
    });
  }

  function calculateGeometry() {
    theWeekDaySectionHeight = theWeekDaySection.height();
    theWeekDaySectionOffsetTop = theWeekDaySection.offset().top;
  }
})((window.el.TheWeekDayView = window.el.TheWeekDayView || {}), jQuery);
